import React, { Component } from "react";
import {} from "reactstrap";

class AgendaFooter extends Component {
  render() {
    return (
      <div>
        <div className="container" id="footer">
          <h4>Comment ça marche ?</h4>
          <h5>Périmètre</h5>
          <p>
            Concernant les événements susceptibles d'apparaître dans notre calendrier, notre périmètre ne s'étend pas
            au-delà du territoire du Pays Messin (agglomération). Les demandes concernant des lieux en dehors de ce
            périmètre ne pourront être prises en compte.
          </p>
          <h5>Diffusion</h5>
          <p>
            La rédaction définira les évènements à mettre en avant sur l'agenda du site metz.fr ainsi que la page
            Facebook de la Ville de Metz. Ces supports, mis à la disposition des associations, sont destinés à la
            promotion des manifestations locales. La publicité à but commercial en est exclue. La mairie reste juge de
            l'opportunité de la diffusion des messages qui lui sont proposés. Votre information sera publiée dans les
            meilleurs délais.
          </p>
          <h5>Informations personnelles</h5>
          <p>
            M. Le Maire est le responsable des traitements de la Ville de Metz. Les informations recueillies par le
            Cabinet du Maire, font l’objet d’un traitement informatique destiné à Publier des évènements sur metz.fr Les
            informations enregistrées sont utilisées par les services de la Ville de Metz. Vos données à caractère
            personnel sont conservées 6 mois. Conformément aux articles 15 à 23 du Règlement 2016/679 du Parlement
            Européen et du Conseil du 27 avril 2016, toute personne peut obtenir communication et, le cas échéant,
            rectification, effacement, limitation du traitement, opposition et limitation des informations la
            concernant, pour motif légitime. Vous pouvez exercer ces droits, sous réserve de la fourniture d’une pièce
            justificative d’identité, auprès de la ville de Metz à l’adresse suivante :
            <br />
            Hôtel de Ville de Metz, à l’attention du DPO
            <br />
            1, place d’Armes – J.F. Blondel – 57036 METZ Cedex 1
            <br />
            Téléphone : 0 800 891 891
          </p>
        </div>
        <br />
        <br />
        <br />
        <footer className="footer" id="footer2">
          <div className="container">
            <span className="text-muted">
              <a rel="noopener noreferrer" href="https://metz.fr/ressources/informations_legales.php" target="_blank">
                Informations légales
              </a>{" "}
              -{" "}
              <a rel="noopener noreferrer" href="https://metz.fr/ressources/credit.php" target="_blank">
                Crédits
              </a>
            </span>
          </div>
        </footer>
      </div>
    );
  }
}

export default AgendaFooter;



// WEBPACK FOOTER //
// ./src/AgendaFooter.jsx